<template>
  <div id="accordion" class="
      h-100
      d-flex
      flex-column
      justify-content-center
      p-4
      overflow-y-auto
      body-bg
    ">
    <div class="container-md shadow-sm p-0 mx-auto bg-white">
      <div class="p-5">
        <h1 class="h1 mb-4 text-uppercase font-medium">Login</h1>
        <form @submit.prevent>
          <div class="collapse show" id="divLogin" data-parent="#accordion">
            <div class="form-group required">
              <input type="text" name="userName" class="form-control" id="txtEmail" maxlength="150" tabindex="1"
                required="" isemail="" v-model="user.userName"
                title="Verwenden Sie bitte Ihr E-Mail-Login Konto, welches Sie bei der Registrierung angegeben haben." />
              <label class="floating-label"><span>E-Mail</span></label>


              <b-icon-question-circle id="tooltip-target-1" style="position: absolute;top:-10px;left: 70px">
                Hover Me
              </b-icon-question-circle>
              <b-tooltip target="tooltip-target-1" triggers="hover">
                Verwenden Sie bitte Ihr E-Mail-Login Konto, welches Sie bei der Registrierung angegeben haben.
              </b-tooltip>
            </div>
            <div class="form-group input-group required">
              <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control" style="border:none!important"
                id="txtPassword" maxlength="50" name="password" tabindex="2" required="" v-model="user.Password"
                title="Verwenden Sie bitte Ihr Passwort, welches Sie bei der Registrierung angegeben haben." />
              <label class="floating-label"><span>Passwort</span></label>

              <b-icon-question-circle id="tooltip-target-2" style="position: absolute;top:-10px;left: 70px">
                Hover Me
              </b-icon-question-circle>
              <b-tooltip target="tooltip-target-2" triggers="hover">
                Verwenden Sie bitte Ihr Passwort, welches Sie bei der Registrierung angegeben haben.
              </b-tooltip>
              <div class="input-group-append">
                <button class="btn btn-icon" @click="showPassword = !showPassword" type="button">
                  <i class="material-icons">visibility</i>
                </button>
              </div>
            </div>
            <div class="form-check form-group">
              <input type="checkbox" class="form-check-input" id="chkRememberMe" />
              <label class="form-check-label" for="chkRememberMe" tabindex="3">
                Passwort merken
              </label>
            </div>

            <div v-if="loginHasError" id="pErrorSummary" class="alert alert-danger" role="alert">
              {{ loginErrorMessage }}
            </div>
            <div class="mt-3">
              <button
                type="button"
                class="btn btn-primary"
                id="btnLogin"
                @click="login()"
                :disabled="isLoggingIn"
                tabindex="6"
              >
                <span v-if="isLoggingIn">Bitte warten...</span>
                <span v-else>LOGIN</span>
              </button>
              <a href="/signup" class="btn btn-border ml-1" tabindex="7">Registrieren</a>
              <a href="javascript:void(0);" class="btn btn-border ml-1"
                @click="forgotPasswordModal = !forgotPasswordModal" tabindex="8">Passwort
                vergessen?</a>

              <a href="javascript:void(0);" class="btn btn-border ml-1" @click="helpModal = !helpModal" tabindex="8">Hilfe
                anfordern</a>
            </div>
          </div>
        </form>



        <b-modal hide-footer :size="$root.$children[0].baseModalSize" centered v-model="helpModal" title="BootstrapVue">
          <template #modal-header="{ close }">
            <h5 class="modal-title">Hilfe anfordern</h5>
            <b-icon-x font-scale="3" style="color: #ccc" @click="closeHelpDialog()" class="closeIcon"></b-icon-x>
          </template>

          <div class="text-center">
            <p>
              Probleme bei der Anmeldung oder Registrierung?</p>
            <p>Wir unterstützen Sie selbstverständlich:</p>
            <p>Unter der E-Mail Adresse : <a href="mailto:support@ozgservices.de">support@ozgservices.de</a></p>
            <p>Unter der Service Telefonnummer: <a href="tel:+49 (0)6196 95 44 - 56">+49 (0)6196 95 44 - 563</a></p>

          </div>


          <template #modal-footer="{ ok, cancel, hide }">
          </template>
        </b-modal>


        <b-modal :size="$root.$children[0].baseModalSize" centered v-model="forgotPasswordModal" title="BootstrapVue">
          <template #modal-header="{ close }">
            <h5 class="modal-title">Passwort zurücksetzen</h5>
            <b-icon-x font-scale="3" style="color: #ccc" @click="closeDialog()" class="closeIcon"></b-icon-x>
          </template>

          <div class="form-group required">
            <input type="text" class="form-control" v-model="user.UserName" placeholder="E-Mail" required="" isemail=""
              id="txtForgotPassWord" />
            <label class="floating-label"><span>E-Mail</span></label>
            <small class="form-text text-muted">Wir werden Ihre Daten unter keinen Umständen an Dritte weiterreichen.</small>
          </div>


          <div class="alert alert-success fmessage" v-if="!forgotPasswordHasError && sendLink" role="alert" id="dvFsuccess">
            Falls zu dieser E-Mail-Adresse ein Benutzerkonto existiert, erhalten Sie eine E-Mail mit weiteren Anweisungen.
          </div>
          <div class="alert alert-danger fmessage" v-if="forgotPasswordHasError && sendLink" role="alert" id="dvFerror">
            {{ forgotPasswordMessage || "Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut." }}
          </div>
          <template #modal-footer="{ ok, cancel, hide }">
            <button
              class="btn btn-primary"
              @click="SendResetRequest();"
              :disabled="isSendingResetLink"
            >
              <span v-if="isSendingResetLink">Bitte warten...</span>
              <span v-else>Senden</span>
            </button> </template>
        </b-modal>


        <div class="mt-3">
          © 2019 - {{ currentYear }}
          <a href="https://ozgservices.de" target="_blank">www.ozgservices.de</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import config from "../config/config.js";
import axios from "axios";
import moment from "moment";

export default {
  data: function () {
    return {
      showPassword: false,
      hasError: false,
      loginHasError: false,
      forgotPasswordHasError: false,
      notActiveUser: false,
      rateLimited: false,
      rateLimitMessage: "",
      loginErrorMessage: "",
      forgotPasswordMessage: "",
      isLoggingIn: false,
      sendLink: false,
      helpModal: false,
      forgotPasswordModal: false,
      isSendingResetLink: false,

      currentYear: moment().format("YYYY"),
      user: {
        UserName: "",
        Password: "",
        ApplicationKey: config.APP_KEY,
      },
    };
  },
/*
  mounted() {
    let guuid = this.$route.params.guuid;
    axios
      .get(config.API_URL + "api/attempt/" + guuid, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        this.attemptData = response.data;
        this.user.ApplicationKey = response.data.applicationKey;
      });
  },
  */

  mounted() {
  let guuid = this.$route.params.guuid;

  if (!guuid) {
    this.user.ApplicationKey = config.APP_KEY;
    return;
  }

  axios
    .get(config.API_URL + "api/attempt/" + guuid, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      this.attemptData = response.data;

      if (response.data && response.data.applicationKey) {
        this.user.ApplicationKey = response.data.applicationKey;
      } else {
        this.user.ApplicationKey = config.APP_KEY;
      }
    })
    .catch(() => {
      this.user.ApplicationKey = config.APP_KEY;
    });
},

    methods: {

    setLoginError(message) {
      this.loginHasError = true;
      this.hasError = true;
      this.loginErrorMessage = message || "";

      this.$nextTick(() => {
        const el = document.getElementById("pErrorSummary");
        if (el) {
          el.innerText = this.loginErrorMessage;
        }
      });
    },

    buildLoginErrorMessage(error) {
      const status = error.response ? Number(error.response.status) : 0;

      let data = {};

      if (error.response && error.response.data) {
        data = error.response.data;

        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (e) {
            data = {};
          }
        }
      }

      console.log("LOGIN ERROR STATUS:", status);
      console.log("LOGIN ERROR DATA:", data);

      if (status === 429) {
        const retryAfterSeconds = Number(data.retryAfterSeconds || 0);
        let minutes = Math.ceil(retryAfterSeconds / 60);

        if (!minutes || minutes < 1) {
          minutes = 1;
        }

        if (data.code === "account_locked") {
          return (
            "Das Benutzerkonto wurde wegen zu vieler fehlgeschlagener Anmeldeversuche vorübergehend gesperrt. Bitte versuchen Sie es in ca. " +
            minutes +
            " Minute(n) erneut."
          );
        }

        return (
          "Zu viele fehlgeschlagene Anmeldeversuche. Bitte versuchen Sie es in ca. " +
          minutes +
          " Minute(n) erneut."
        );
      }

      return "Die Anmeldung ist fehlgeschlagen. Bitte überprüfen Sie E-Mail-Adresse und Passwort.";
    },


    login() {
      console.log("LOGIN METHOD STARTED - AKTUELLE LOGIN.VUE");

      if (this.isLoggingIn) {
        return;
      }

      let self = this;
      self.isLoggingIn = true;

      self.hasError = false;
      self.loginHasError = false;
      self.notActiveUser = false;
      self.rateLimited = false;
      self.rateLimitMessage = "";
      self.loginErrorMessage = "";

      if (!this.user.ApplicationKey) {
        console.error("ApplicationKey fehlt vor Login", this.user);
        self.hasError = true;
        self.loginErrorMessage =
          "Die Anmeldung kann nicht gestartet werden, weil die Anwendungskonfiguration fehlt.";
        self.isLoggingIn = false;
        return;
      }

      axios
        .post(config.API_URL + "/api/Authenticate/", this.user, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          const status = Number(response.status);
          const token = response.data;

          console.log("LOGIN THEN STATUS:", status);
          console.log("LOGIN THEN DATA:", response.data);

          if (status === 429) {
            const message = self.buildLoginErrorMessage({ response: response });

            self.notActiveUser = false;
            self.rateLimited = true;
            self.rateLimitMessage = message;
            self.setLoginError(message);

            console.log("LOGIN THEN 429 MESSAGE:", message);
            return;
          }

          if (status === 401) {
            self.notActiveUser = false;
            self.rateLimited = false;
            self.rateLimitMessage = "";
            self.setLoginError(
              "Die Anmeldung ist fehlgeschlagen. Bitte überprüfen Sie E-Mail-Adresse und Passwort."
            );

            console.log("LOGIN THEN 401 MESSAGE:", self.loginErrorMessage);
            return;
          }

          if ((status === 201 || status === 200) && token !== "USER_NOT_ACTIVE") {
            localStorage.setItem("ozgJwt", token);

            self.hasError = false;
            self.loginHasError = false;
            self.notActiveUser = false;
            self.rateLimited = false;
            self.rateLimitMessage = "";
            self.loginErrorMessage = "";

            window.location = "/?t=" + token;
            return;
          }

          if (token === "USER_NOT_ACTIVE") {
            self.notActiveUser = true;
            self.rateLimited = false;
            self.rateLimitMessage = "";
            self.setLoginError(
              "Das Benutzerkonto wurde deaktiviert. Bitte wenden Sie sich an Ihren Administrator."
            );
            return;
          }

          self.notActiveUser = false;
          self.rateLimited = false;
          self.rateLimitMessage = "";
          self.setLoginError(
            "Die Anmeldung ist fehlgeschlagen. Bitte überprüfen Sie E-Mail-Adresse und Passwort."
          );
        })
          .catch((error) => {
            self.notActiveUser = false;
            self.rateLimited = false;
            self.rateLimitMessage = "";

            const message = self.buildLoginErrorMessage(error);

            if (error.response && Number(error.response.status) === 429) {
              self.rateLimited = true;
              self.rateLimitMessage = message;
            }

            self.setLoginError(message);

            console.log("LOGIN ERROR MESSAGE:", message);
          })
          .finally(() => {
            self.isLoggingIn = false;
          });
    },

    closeDialog() {
      this.forgotPasswordModal = false;
    },

    closeHelpDialog() {
      this.helpModal = false;
    },

    SendResetRequest() {
      if (this.isSendingResetLink) {
        return;
      }

      let self = this;

      self.isSendingResetLink = true;
      self.forgotPasswordMessage = "";
      self.sendLink = false;
      self.forgotPasswordHasError = false;

      axios
        .post(
          config.API_URL + "/api/ForgotPassword",
          { userMail: this.user.UserName },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          self.sendLink = true;

          if (response.status == "201" || response.status == "200") {
            self.forgotPasswordHasError = false;
          } else if (response.status == 500) {
            self.forgotPasswordHasError = true;
          } else {
            self.forgotPasswordHasError = true;
          }
        })
        .catch((error) => {
          self.sendLink = true;
          self.forgotPasswordHasError = true;

          let message = "Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.";
          let data = {};

          if (error.response && error.response.data) {
            data = error.response.data;

            if (typeof data === "string") {
              try {
                data = JSON.parse(data);
              } catch (e) {
                data = {};
              }
            }
          }

          if (data.messageDe) {
            message = data.messageDe;
          }

          if (
            error.response &&
            Number(error.response.status) === 429 &&
            data.retryAfterSeconds
          ) {
            const retryAfterSeconds = Number(data.retryAfterSeconds || 0);
            const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60));

            message =
              message +
              " Bitte versuchen Sie es in ca. " +
              minutes +
              " Minute(n) erneut.";
          }

          self.forgotPasswordMessage = message;
        })
        .finally(() => {
          self.isSendingResetLink = false;
        });  
      },
    },
  };
</script>

<style></style>